import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  MDBInputGroup,
  MDBInput,
  MDBCarousel,
  MDBCarouselElement,
  MDBCarouselInner,
  MDBCarouselItem,
} from "mdb-react-ui-kit";
import ArticuloService from "../../services/articulo.service";
import Switch from "react-switch";
import { Container, Row, Col, Button } from "react-bootstrap/";
import { toast } from "react-toastify";
import { useCart } from "react-use-cart";
import {
  calcularPrecioVenta,
  obtenerGananciaEfectiva,
} from "../../utils/precios";
import { esVideo } from "../../utils/media";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EventBus from "../../common/EventBus";

require("dotenv").config();
const API_URL = process.env.REACT_APP_URL;
const TIENDA_SEARCH_KEY = "tienda_search";

const ProductoDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const articuloFromState = location.state?.articulo;
  const carouselRef = useRef(null);

  const [articulo, setArticulo] = useState(articuloFromState || null);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState();
  const [BASEURL, setBASEURL] = useState();
  const [ganancia, setGanancia] = useState();
  const [resultado, setResultado] = useState(0);
  const [cantidad, setCantidad] = useState(1);
  const [totalFinal, setTotalFinal] = useState();
  const [switchChecked, setSwitchChecked] = useState(false);
  const [formato, setFormato] = useState("");
  const [formatoFiltrado, setFormatoFiltrado] = useState();
  const [unidadVisible, setUnidadVisible] = useState(false);
  const [observacionElegido, setObservacionElegido] = useState("");
  const [elegido, setElegido] = useState("");

  const { addItem, updateItemQuantity, items } = useCart();

  // Un solo useEffect que carga TODO y solo al final setea loading=false
  useEffect(() => {
    let cancelled = false;

    const cargarTodo = async () => {
      setLoading(true);

      let art = articulo;

      // 1. Si no tenemos el artículo, lo buscamos
      if (!art) {
        try {
          const res = await ArticuloService.getTodos();
          const found = res.data.find(
            (a) => String(a.articulos_id) === String(id)
          );
          if (found) {
            art = found;
            if (!cancelled) setArticulo(found);
          } else {
            if (!cancelled) {
              toast.error("Artículo no encontrado");
              navigate("/tienda");
            }
            return;
          }
        } catch (e) {
          if (!cancelled) {
            if (e.response && e.response.status === 401) {
              EventBus.dispatch("logout");
            } else {
              toast.error("Error al cargar el artículo");
              navigate("/tienda");
            }
          }
          return;
        }
      }

      if (!art || cancelled) return;

      // 2. Calculamos precio
      const user = JSON.parse(localStorage.getItem("user"));
      const gananciaGlobal = user?.ganancia || 0;
      const gananciaEfectiva = obtenerGananciaEfectiva(art, gananciaGlobal);
      if (!cancelled) {
        setGanancia(gananciaEfectiva);
        setFormato(art.FORMATO || "");
      }

      const resultadoInicial = calcularPrecioVenta(art, gananciaGlobal);

      if (!cancelled) {
        setResultado(resultadoInicial);
        setTotalFinal(resultadoInicial);
      }

      // 3. Estado del carrito
      const enCarrito = items.find(
        (element) => element.id === art.articulos_id
      );
      if (!cancelled) {
        if (enCarrito != null) {
          setElegido(enCarrito);
          if (enCarrito.observacion != "") {
            setObservacionElegido(enCarrito.observacion);
          }
        } else {
          setElegido("");
        }
      }

      // 4. Imagenes
      if (!cancelled) {
        setBASEURL(API_URL + "/Images/" + art.articulos_id + "/");
      }

      try {
        const resFotos = await ArticuloService.getFotosArticulo(art.articulos_id);
        if (!cancelled) {
          if (resFotos.data.files && resFotos.data.files[0] === "Gris.png") {
            setImage("/public/Gris.png");
          } else {
            setImage(resFotos.data.files);
          }
        }
      } catch (e) {
        if (!cancelled) {
          if (e.response && e.response.status === 401) {
            EventBus.dispatch("logout");
          } else {
            setImage("/public/Gris.png");
          }
        }
      }

      // 5. Solo ahora terminamos de cargar
      if (!cancelled) {
        setLoading(false);
      }
    };

    cargarTodo();

    return () => {
      cancelled = true;
    };
  }, [id, articulo, items, navigate]);

  useEffect(() => {
    const carouselEl = carouselRef.current;
    if (!carouselEl) return;

    const handleSlid = () => {
      const activeItem = carouselEl.querySelector('.carousel-item.active');
      if (activeItem) {
        const video = activeItem.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      }
    };

    carouselEl.addEventListener('slid.bs.carousel', handleSlid);
    return () => {
      carouselEl.removeEventListener('slid.bs.carousel', handleSlid);
    };
  }, []);

  // Al salir del detalle hacia una ruta que NO sea tienda, limpiamos la búsqueda guardada
  useEffect(() => {
    return () => {
      const nextPath = window.location.pathname;
      if (!nextPath.startsWith("/tienda")) {
        try {
          sessionStorage.removeItem(TIENDA_SEARCH_KEY);
        } catch {
          // ignore
        }
      }
    };
  }, []);

  const handleAddToCart = () => {
    if (!articulo) return;
    const qty = parseFloat(cantidad) || 1;
    const product = {
      id: articulo.articulos_id,
      name: articulo.descri,
      price: articulo.PRE_VTA,
      observacion: document.getElementById("observacion-detalle")?.value || "",
    };

    const idx = items.findIndex((element) => element.id === articulo.articulos_id);
    if (idx === -1) {
      addItem(product, qty);
      toast.success(
        <div>
          Artículo {articulo.descri}
          <br />
          Cantidad: {qty} <br /> Agregado correctamente
        </div>,
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          whiteSpace: "pre-line",
        }
      );
    } else {
      items[idx].observacion = observacionElegido;
      updateItemQuantity(articulo.articulos_id, qty);
      toast.success("Cantidad actualizada correctamente", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        whiteSpace: "pre-line",
      });
    }
  };

  const cambioCalculo = () => {
    let auxGanancia = document.getElementById("ganancia-detalle")?.value;
    if (!auxGanancia || auxGanancia === "") {
      const user = JSON.parse(localStorage.getItem("user"));
      const gananciaGlobal = user?.ganancia || 0;
      auxGanancia = obtenerGananciaEfectiva(articulo, gananciaGlobal);
    }
    const gananciaNum = parseFloat(auxGanancia) || 0;
    const auxPrecio = calcularPrecioVenta(
      { ...articulo, ganancia_personalizada: gananciaNum },
      0
    );
    let auxPrecioFinal = auxPrecio;
    let auxCantidad = document.getElementById("cantidad-detalle")?.value;
    if (!auxCantidad || auxCantidad === "") auxCantidad = 1;
    setResultado(parseFloat(auxPrecioFinal));
    setTotalFinal(parseFloat(auxCantidad) * parseFloat(auxPrecioFinal));
  };

  const handleSwitchChange = (checked) => {
    if (checked) {
      var matches = formato.match(/[+-]?([0-9]*[.])?[0-9]+/);
      if (matches == null) {
        setFormatoFiltrado(1);
        setResultado(parseFloat(totalFinal) / parseFloat(cantidad));
        setTotalFinal(parseFloat(totalFinal));
      } else {
        setFormatoFiltrado(matches[0]);
        setResultado(
          parseFloat(totalFinal) / parseFloat(matches[0]) / parseFloat(cantidad)
        );
        setTotalFinal(parseFloat(totalFinal) / parseFloat(matches[0]));
      }
      setUnidadVisible(true);
    } else {
      setUnidadVisible(false);
      cambioCalculo();
    }
    setSwitchChecked(checked);
  };



  if (loading) {
    return (
      <Container fluid className="tienda-container">
        <div className="tienda-detalle-loading">
          <div className="tienda-skeleton-image" style={{ height: 300, maxWidth: 600 }} />
          <div style={{ maxWidth: 500, width: "100%", marginTop: 20 }}>
            <div className="tienda-skeleton-text tienda-skeleton-price" />
            <div className="tienda-skeleton-text tienda-skeleton-title" />
            <div className="tienda-skeleton-text tienda-skeleton-title" />
          </div>
        </div>
      </Container>
    );
  }

  if (!articulo) return null;

  const tieneImagen = image && image !== "/public/Gris.png";

  return (
    <Container fluid className="tienda-container">
      <div className="tienda-detalle">
        {/* Botón volver */}
        <button
          className="tienda-detalle-back"
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon />
          <span>Volver a la tienda</span>
        </button>

        <Row className="g-4">
          {/* Columna Imagen */}
          {tieneImagen && (
            <Col lg={6} className="tienda-detalle-gallery">
              <MDBCarousel ref={carouselRef} showControls showIndicators dark>
                <MDBCarouselInner>
                  {image.map((img, idx) => (
                    <MDBCarouselItem
                      key={idx}
                      className={idx === 0 ? "active" : ""}
                    >
                      <div className="tienda-gallery-frame">
                        {esVideo(img) ? (
                          <video
                            src={BASEURL + encodeURIComponent(img)}
                            autoPlay
                            muted
                            playsInline
                            controls
                            className="tienda-carousel-video"
                            onError={(e) => {
                              console.warn(`[Detalle] Error cargando video ${img}:`, e);
                            }}
                            onEnded={() => {
                              document.querySelector('.carousel-control-next')?.click();
                            }}
                          />
                        ) : (
                          <MDBCarouselElement src={BASEURL + encodeURIComponent(img)} />
                        )}
                      </div>
                    </MDBCarouselItem>
                  ))}
                </MDBCarouselInner>
              </MDBCarousel>
            </Col>
          )}

          {/* Columna Info */}
          <Col lg={tieneImagen ? 6 : 8} className="tienda-detalle-info mx-auto">
            <h1 className="tienda-detalle-title">{articulo.descri}</h1>
            <p className="tienda-detalle-code">
              Código: {articulo.codigo} | Barras: {articulo.codi_barra}
            </p>

            <div className="tienda-detalle-prices-row">
              <div className="tienda-detalle-price-cost">
                <span className="tienda-label">Precio de costo</span>
                <div className="tienda-detalle-price-block">
                  <span className="tienda-detalle-price-symbol">$</span>
                  <span className="tienda-detalle-price">
                    {articulo.PRE_VTA ? parseFloat(articulo.PRE_VTA).toFixed(2) : "0.00"}
                  </span>
                </div>
              </div>
              <div className="tienda-detalle-price-sell">
                <span className="tienda-label">Precio de venta</span>
                <div className="tienda-detalle-price-block-sell">
                  <span className="tienda-detalle-price-symbol-sell">$</span>
                  <span className="tienda-detalle-price-amount-sell">
                    {resultado.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            <div className="tienda-detalle-meta">
              <div className="tienda-detalle-meta-item">
                <span className="tienda-label">Formato:</span>
                <b>{articulo.FORMATO}</b>
              </div>
              <div className="tienda-detalle-meta-item">
                <span className="tienda-label">Fecha Precio:</span>
                <b>{articulo.FEC_OBSERV}</b>
              </div>
            </div>

            {/* Calculadora */}
            <div className="tienda-detalle-calculadora">
              <h5 className="tienda-section-title">Cálculo de Ganancia</h5>
              <p className="tienda-ganancia-default">
                {articulo.ganancia_personalizada !== null && articulo.ganancia_personalizada !== undefined
                  ? `Ganancia Personalizada: ${parseFloat(articulo.ganancia_personalizada).toFixed(2)}%`
                  : `Ganancia Predeterminada: ${ganancia}%`}
              </p>

              <MDBInputGroup
                className="mb-3 tienda-input-group"
                textAfter="%"
              >
                <MDBInput
                  id="ganancia-detalle"
                  type="text"
                  pattern="[0-9]+([\.][0-9]{1,2})?"
                  min="0"
                    onChange={(e) => {
                    let str = e.target.value.replace(/[^0-9\.]+/g, "");
                    e.target.value = str;
                    if (str.includes(".")) {
                      let count = str.match(/\./g).length;
                      if (count > 1) e.target.value = str.slice(0, -1);
                    }
                    let resultado = calcularPrecioVenta(
                      {
                        ...articulo,
                        ganancia_personalizada:
                          parseFloat(e.target.value) || 0,
                      },
                      0
                    );
                    if (isNaN(resultado)) resultado = 0;
                    if (switchChecked && formatoFiltrado) {
                      resultado = resultado / parseFloat(formatoFiltrado);
                    }
                    setResultado(resultado);
                    setTotalFinal(parseFloat(cantidad) * parseFloat(resultado));
                  }}
                />
              </MDBInputGroup>

              {formato && (
                <div className="tienda-switch-row">
                  <span>Precio Unitario</span>
                  <Switch
                    onChange={handleSwitchChange}
                    checked={switchChecked}
                    className="react-switch"
                    id="normal-switch-detalle"
                  />
                </div>
              )}

              <h6
                className="tienda-unidad"
                style={{ visibility: unidadVisible ? "visible" : "hidden" }}
              >
                Unidad: {formatoFiltrado}
              </h6>

              <Row>
                <Col sm={6}>
                  <h6 className="tienda-label">Cantidad</h6>
                  <MDBInputGroup
                    className="mb-3 tienda-input-group"
                    textBefore="x"
                  >
                    <MDBInput
                      id="cantidad-detalle"
                      type="text"
                      pattern="[0-9]+([\.][0-9]{1,2})?"
                      min="0"
                      onChange={(e) => {
                        let str = e.target.value.replace(/[^0-9\.]+/g, "");
                        e.target.value = str;
                        if (str.includes(".")) {
                          let count = str.match(/\./g).length;
                          if (count > 1) e.target.value = str.slice(0, -1);
                        }
                        setCantidad(e.target.value || 1);
                        setTotalFinal(
                          parseFloat(e.target.value || 1) *
                            parseFloat(resultado)
                        );
                      }}
                      placeholder={cantidad}
                    />
                  </MDBInputGroup>
                </Col>
                <Col sm={6}>
                  <h6 className="tienda-label">Total</h6>
                  <MDBInputGroup
                    className="mb-3 tienda-input-group"
                    textBefore="$"
                  >
                    <MDBInput
                      id="totalFinal-detalle"
                      type="number"
                      min="0"
                      placeholder="Total Final"
                      readOnly
                      value={totalFinal ? totalFinal.toFixed(2) : "0.00"}
                    />
                  </MDBInputGroup>
                </Col>
              </Row>
            </div>

            {/* Carrito */}
            <div className="tienda-detalle-carrito">
              <h5 className="tienda-section-title">Agregar al Carrito</h5>
              <textarea
                id="observacion-detalle"
                placeholder="Observación sobre el producto (Opcional)"
                rows="3"
                className="tienda-textarea"
                value={observacionElegido}
                onChange={(e) => setObservacionElegido(e.target.value)}
                onBlur={(e) => {
                  let idx = items.findIndex(
                    (element) => element.id === articulo.articulos_id
                  );
                  if (idx !== -1) {
                    items[idx].observacion = observacionElegido;
                    updateItemQuantity(
                      articulo.articulos_id,
                      parseFloat(items[idx].quantity)
                    );
                  }
                }}
              />

              <div className="tienda-detalle-actions">
                <Button
                  variant="primary"
                  className="tienda-detalle-btn-add"
                  onClick={handleAddToCart}
                >
                  <ShoppingCartIcon />
                  <span>Agregar al carrito</span>
                </Button>
              </div>

              {elegido !== "" && (
                <p className="tienda-en-carrito">
                  Hay {elegido.quantity} items en el carrito de este artículo.
                </p>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ProductoDetalle;
